import { useSelector } from 'react-redux';
import { CaseStudyOnboardingTourStepFeature, CaseStudyOnboardingTourStepMetrics } from './CaseStudyOnboardingTour';
import { getModuleIdsByBuiltinType } from 'ContentEditorUI/redux/selectors/moduleSchemaSelectors';
import { useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const TourStepWrapper = ({
  moduleSchema,
  widget,
  children
}) => {
  const moduleId = moduleSchema === null || moduleSchema === void 0 ? void 0 : moduleSchema.moduleId;
  const moduleIdsByBuiltinType = useSelector(getModuleIdsByBuiltinType);
  const TourStepComponent = useMemo(() => {
    // explicitly check for invalid moduleId in case both moduleId and values of moduleIdsByBuiltinType are undefined
    if (!moduleId) {
      return null;
    }
    const tourStepComponents = {
      [moduleIdsByBuiltinType === null || moduleIdsByBuiltinType === void 0 ? void 0 : moduleIdsByBuiltinType.cs_featured_details]: CaseStudyOnboardingTourStepFeature,
      [moduleIdsByBuiltinType === null || moduleIdsByBuiltinType === void 0 ? void 0 : moduleIdsByBuiltinType.cs_metrics]: CaseStudyOnboardingTourStepMetrics
    };
    return tourStepComponents[moduleId];
  }, [moduleId, moduleIdsByBuiltinType]);
  return TourStepComponent ? /*#__PURE__*/_jsx(TourStepComponent, {
    widget: widget,
    children: children
  }) : children;
};